export const mobileUtil = {
    getMobile (mobile) {
        if (!mobile) {
            return '';
        }

        return mobile.replace(/\s*/g, '');
    },
};
